
































































































































































import {Component, Vue} from "vue-property-decorator";
import DocumentService from "@/services/DocumentService";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import {namespace} from "vuex-class";
import {STATE_LIST} from "@/constants/ProfileConstants";
import SaveW4RequestDTO, {FilingStatus, FillW4Request} from "@/dto/archive/SaveW4RequestDTO";
import AutoComplete from "@/components/common/AutoComplete.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import AutoCompleteDTO from "@/components/common/AutoCompleteDTO";
import {ifValid} from "@/utils/ComponentUtils";
import RouteNames from "@/router/RouteNames";
import {FillableDocumentStatus} from "@/dto/archive/FillableDocumentStatus";
import {CDRQRecordStatuses} from "@/components/request/cdrq/CDQR_DTOs";
import Notifications from "@/state/Notifications";
import {debounce} from "typescript-debounce-decorator";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import {hashCode} from "@/utils/StringUtils";

const AppModule = namespace("App");

@Component({
	methods: {hashCode},
	components: {PortalCheckbox, PortalSelect, PortalAddress, PortalInput, AutoComplete},
	computed: {
		AutoCompleteDTO() {
			return AutoCompleteDTO
		},
		FillableDocumentStatus() {
			return FillableDocumentStatus;
		}
	}
})
export default class FormW4 extends Vue {

	private id?: number;
	private publicId?: string;

	private successful = false;

	private message = "";

	private minOtherAmount = 0;

	@AppModule.State
	private loading!: boolean;

	@AppModule.Action
	private startLoading!: () => void

	@AppModule.Action
	private stopLoading!: () => void

	private exists = true;

	private processed = false;

	private request = new FillW4Request();

	private addressHash = hashCode(JSON.stringify(this.request.localAddress))

	get fillingStatusOptions(): Array<SelectOption> {
		return [
			SelectOption.builder().title(this.$t('archive.w4.filling_status.single_or_married_separately').toString()).value(FilingStatus.SINGLE_OR_MARRIED_SEPARATELY).build(),
			SelectOption.builder().title(this.$t('archive.w4.filling_status.married_or_qualifying_widow').toString()).value(FilingStatus.MARRIED_OR_WIDOW).build(),
			SelectOption.builder().title(this.$t('archive.w4.filling_status.head_of_household').toString()).value(FilingStatus.HEAD_OF_HOUSEHOLD).build()
		]
	}

	public created(): void {
		let hint2000 = this.$t("archive.w4.children_hint").toString()
		let hint500 = this.$t("archive.w4.other_deps_hint").toString()
		this.$validator.extend(
			"zeroOrMultiplesOf2200",
			{
				validate: value => {
					const num = Number(value)
					return num == null || num == 0 || (num > 0 && num % 2200 === 0);
				},
				getMessage(field: string, params: any[], data: any): string {
					return hint2000
				}
			}
		)
		this.$validator.extend(
			"zeroOrMultiplesOf500",
			{
				validate: value => {
					const num = Number(value)
					return num == null || num == 0 || (num > 0 && num % 500 === 0);
				},
				getMessage(field: string, params: any[], data: any): string {
					return hint500
				}
			}
		)
		if(this.$route.name == RouteNames.PUBLIC_FORMS_W4) {
			this.publicId = this.$route.params.publicId!;
			this.loadPublicForm();
		} else{
			this.id = Number.parseInt(this.$route.params.id)!;
			this.loadInternalForm();
		}
	}

	private calculateTotalAmount() {
		let res = 0;
		if (this.request.qualifyingChildrenUnder17) {
			res += +this.request.qualifyingChildrenUnder17
		}
		if (this.request.otherDependents) {
			res += +this.request.otherDependents
		}
		this.request.otherAmount = res !== 0 ? +res : undefined;
		if (this.request.otherAmount) {
			this.minOtherAmount = res
		}
	}

	private loadPublicForm(): void{
		this.startLoading();
		DocumentService.loadPreparedPublicFormW4(this.$route.params.publicId).then(
			success => {
				if (success.data.status === FillableDocumentStatus.PENDING_SIGNATURE) {
					this.goToSignature(success.data.signerPublicId as string)
				} else {
					this.publicId = this.$route.params.publicId
					this.request = new FillW4Request(success.data);
					if (success.data.localAddress) {
						this.addressHash = hashCode(JSON.stringify(success.data.localAddress))
					}
				}
				this.stopLoading();
			},
			error => {
				this.exists = false;
				this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
				this.successful = false;
				this.stopLoading();
			});
	}

	private loadInternalForm(): void{
		this.startLoading();
		DocumentService.loadPreparedFormW4(Number.parseInt(this.$route.params.id)).then(
			success => {
				this.id = Number.parseInt(this.$route.params.id)
				this.request = new FillW4Request(success.data);
				if (success.data.localAddress) {
					this.addressHash = hashCode(JSON.stringify(success.data.localAddress))
				}
				this.stopLoading()
			},
			error => {
				this.exists = false;
				this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string
				this.successful = false;
				this.stopLoading()
			});
	}

	private save(): void {
		if(this.$route.name === RouteNames.PUBLIC_FORMS_W4) {
			this.savePublicForm();
		} else {
			this.saveInternalForm();
		}
	}

	private saveInternalForm(): void {
		ifValid(this, () => {
			this.message = "";
			this.startLoading();
			DocumentService.saveW4(this.id!, this.request).then(
				success => {
					this.successful = true;
					this.processed = true;
					this.$router.push({name: RouteNames.ARCHIVE_W4});
				},
				error => {
					this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
				}
			).then(() => this.stopLoading());
		})
	}

	private savePublicForm(): void {
		ifValid(this, () => {
			this.message = "";
			this.startLoading();
			DocumentService.savePublicW4(this.publicId!, this.request).then(
				success => {
					this.successful = true;
					this.processed = true;
					this.goToSignature(success.data);
				},
				error => {
					this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
				}
			).then(() => this.stopLoading());
		})
	}

	private goToSignature(publicId: string): void {
		this.$router.push({name: RouteNames.SIGN_PUBLIC, params: { publicId }});
	}

}
